export default __webpack_public_path__ + "static/media/hello.7b80a410.svg";